module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/banner_bg-7b713c5e9199933f55a8be3c75029841.svg";